import { render } from "./QuickPayment.vue?vue&type=template&id=442a6bb9&lang=pug"
import script from "./QuickPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickPayment.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__